$(document).ready(function () {
    $("#scroll").click(function (e) {
        e.preventDefault();
        $('html, body').stop().animate({
            scrollTop: $("a[name=states]").offset().top
        }, 1000);
    });
});


// WEBPACK FOOTER //
// ./themes/ldc/assets/js/scroll.js